<template>
  <!-- 退貨統計分析--退貨中心 -->
  <div class="sales-return-content">
    <div class="content-top">
      <div class="analyzed-area">
        <img src="@/assets/refund/icon_locationGray@2x.png" class="icon" />{{
          userInfo.name
        }}
      </div>
      <!-- 受理概览 -->
      <div class="part deal-overview">
        <div class="part-title shouli">
          <span>受理概览</span>
        </div>
        <div class="deak-overview-child">
          <div class="child-title">
            <img src="@/assets/refund/icon_Reback@2x.png" class="icon" />
            累计退货成功
          </div>
          <div class="child-num">
            {{ returnQuantityData.CumulativeReturnSucceeded | numSeparate }}
            <span class="tags">起</span>
          </div>
          <div class="full-desc">
            累计退货申请
            <span class="num">{{
              returnQuantityData.CumulativeReturnApplication | numSeparate
            }}</span>
            起
          </div>
        </div>
        <div class="deak-overview-child">
          <div class="child-title">
            <img src="@/assets/refund/icon_Amount@2x.png" class="icon" />
            累计退款金额
          </div>
          <div class="child-num">
            {{
              moneyFormat(returnQuantityData.CumulativeReturnSucceededMount || 0).num
            }}
            <span class="tags">{{ moneyFormat(returnQuantityData.CumulativeReturnSucceededMount || 0).unit }}</span>
          </div>
          <div class="full-desc">
            累计申请涉及金额
            <span v-if="returnQuantityData" class="num">{{
              moneyFormat(returnQuantityData.CumulativeReturnaMount || 0).num
            }}</span>
            {{ moneyFormat(returnQuantityData.CumulativeReturnaMount || 0).unit }}
          </div>
        </div>
      </div>
      <!-- 协助退货州市分布情况 -->
      <div class="part deal-overview">
        <div class="part-title">
          <span>协助退货州市分布情况</span>
          <div class="switch-btn">
            <div
              @click="changeCityDistribution(0)"
              class="radio"
              :class="{ active: cityDistributionActive === 0 }"
            >
              按数量
            </div>
            <div
              @click="changeCityDistribution(1)"
              class="radio"
              :class="{ active: cityDistributionActive === 1 }"
            >
              按金额
            </div>
          </div>
        </div>
        <returnDistributionMap
          v-if="fieldServiceData"
          style="height: 300px;width: 100%"
          class="histogram"
          :fieldServiceData="fieldServiceData"
          :type="returnQuantityAndSort"
        ></returnDistributionMap>
        <div v-else>暂无数据</div>
      </div>
      <!-- 退货商品分布情况 -->
      <div class="part deal-overview">
        <div class="part-title">
          <span>退货商品分布情况</span>
          <div class="switch-btn">
            <div
              @click="changeProductDistribution(0)"
              class="radio"
              :class="{ active: productDistributionActive === 0 }"
            >
              按数量
            </div>
            <div
              @click="changeProductDistribution(1)"
              class="radio"
              :class="{ active: productDistributionActive === 1 }"
            >
              按金额
            </div>
          </div>
        </div>
        <BarChart
          class="histogram"
          height="200px"
          :dataset="commodityData"
          chartId="commodityMode"
        ></BarChart>
      </div>
      <!-- 处理满意度分布情况 -->
      <div class="part deal-overview">
        <div class="part-title">
          <span>处理满意度分布情况</span>
        </div>
        <div>
          <dashboard-chart :dataset="touristEvaluationData" v-if="touristEvaluationData && touristEvaluationData.length > 0"  />
        </div>
        <van-grid :border="false" :column-num="3" class="processing-satisfaction">
        <van-grid-item v-for="(item, index) in touristEvaluationData" :key="index" @click="toCommonList(item, index)">
          <div class="type">
            <p class="round" :style="{'background-color': touristEvaluationColor[item.type]}"></p>
            <span>{{ item.type }}</span>
          </div>
          <p class="percentage">{{ item.proportion }}</p>
          <div class="number">
            <span>{{ item.count }}起</span>
            <van-icon name="arrow" />
          </div>
        </van-grid-item>
      </van-grid>
      </div>
      <!-- 游客来源地分布TOP10 -->
      <div class="part deal-overview">
        <div class="part-title">
          <span>游客来源地分布TOP10</span>
        </div>
        <BarChart
          class="histogram"
          style="height: 300px;width: 100%"
          height="300px"
          :dataset="customerFromData"
          chartId="customerFromMode"
        ></BarChart>
      </div>
    </div>

    <div class="footer" @click="open">
      <div class="foot-item">
        <img
          class="left-icon"
          src="../../../../assets/refund/icon_filterTime@2x.png"
          alt=""
        />
        <span class="text">{{ time }}</span>
        <img
          class="right-icon"
          src="../../../../assets/refund/icon_ arrowDown@2x.png"
          alt=""
        />
      </div>
    </div>

    <timePopup
      :isPopup="openChooseTimePop"
      @close="close"
      @confirm="confirm"
    ></timePopup>
  </div>
</template>

<script>
    import returnDistributionMap from './chartComponent/returnDistributionMap.vue';
    import BarChart from './chartComponent/BarChart.vue';
    import timePopup from '../components/timePopup.vue';
    import api from '../../../../service/modules/refund';
    import dashboardChart from './chartComponent/dashboardChart.vue';
    import common from '../../../../utils/common'

    // sort => amount按照金额，count按照数量

    export default {
        name: 'salesReturnCenter',
        components: {
            returnDistributionMap,
            BarChart,
            timePopup,
            dashboardChart
        },
        data () {
            return {
                userInfo: {},
                openChooseTimePop: false,
                time: '时间',
                startTime: '',
                endTime: '',
                returnQuantityAndSort: 'count',
                productDistributionSort: 'count',
                cityDistributionActive: 0, // 城市分布
                productDistributionActive: 0, // 商品分布

                returnQuantityData: {}, // 累计退货、金额统计
                fieldServiceData: {}, // 协助退货州市分布情况数据
                commodityData: [], // 协助退货州市分布情况数据
                customerFromData: [], // 游客来源地分布Top10数据
                touristEvaluationColor: {
                    '满意': '#3BC07C',
                    '基本满意': '#66AEF8',
                    '不满意': '#FFB469'
                }, // 分类对应的颜色
                touristEvaluationData: []
            };
        },
        filters: {
            numSeparate (value) {
                var rag = /(\d)(?=(?:\d{3})+$)/g;
                if (!value) {
                    return '0';
                } else {
                    if ((value + '').indexOf('.') != -1) {
                        let num = value.toString().split('.');
                        if (num[1].length > 2) num[1] = '00';
                        return num[0].replace(rag, '$1,') + '.' + num[1];
                    }
                    return (value + '').replace(rag, '$1,');
                }
            }
        },
        created () {
            this.startTime = '';
            this.endTime = '';
            this.currentUser();
        },
        methods: {
            moneyFormat (val) {
                return common.numberFormat(val)
            },
            currentUser () {
                api.currentUser().then((res) => {
                    if (res.ret === 0) {
                        this.userInfo = res.data;
                        this.initData();
                    } else {
                        this.userInfo = {};
                    }
                });
            },
            initData () {
                this.getReturnQuantityAnd();
                this.getFieldService();
                this.getCommodityType();
                this.getTouristEvaluation();
                this.getCustomerComingTop10();
            },
            // 获取退货、金额统计数据
            getReturnQuantityAnd () {
                let params = {
                    reginCode: this.userInfo.regionCode,
                    endTime: this.endTime,
                    startTime: this.startTime
                };
                api.returnQuantityAnd(params).then((res) => {
                    if (res.ret === 0) {
                        this.returnQuantityData = res.data;
                    } else {
                        this.returnQuantityData = {};
                    }
                });
            },
            // 获取协助退货州市分布情况数据
            getFieldService () {
                let params = {
                    reginCode: this.userInfo.regionCode,
                    sort: this.returnQuantityAndSort,
                    endTime: this.endTime,
                    startTime: this.startTime
                };
                api.fieldService(params).then((res) => {
                    let data = {};
                    if (res.ret === 0) {
                        let datalist = res.data.fieldServiceMap;
                        if (datalist.length) {
                            let xDataList = [];
                            let seriesList = [];
                            let tag = '';
                            let priceTag = 1;
                            if (this.returnQuantityAndSort === 'count') {
                                tag = '起';
                                let successCount = [];
                                let count = [];
                                for (let i = 0; i < datalist.length; i++) {
                                    let info = datalist[i];
                                    xDataList.push(info.name);
                                    successCount.push(parseInt(info.successCount));
                                    count.push(parseInt(info.count - info.successCount)); // 特殊处理
                                }
                                seriesList.push({
                                    name: '退货成功',
                                    data: successCount
                                });
                                seriesList.push({
                                    name: '退货申请',
                                    data: count
                                });

                                data = {
                                    tag: tag,
                                    xDataList: xDataList,
                                    seriesList: seriesList
                                };
                            } else {
                                let hasWY = datalist.some(function (currentValue, index, arr) {
                                    return currentValue.amount > 10000;
                                });
                                if (hasWY) {
                                    tag = '万元';
                                    priceTag = 10000;
                                } else {
                                    tag = '元';
                                    priceTag = 1;
                                }
                                let successAmount = [];
                                let amount = [];
                                for (let i = 0; i < datalist.length; i++) {
                                    let info = datalist[i];
                                    xDataList.push(info.name);
                                    successAmount.push(
                                        (parseInt(info.successAmount) / priceTag).toFixed(2)
                                    );
                                    amount.push(
                                        (
                                            parseInt(info.amount - info.successAmount) / priceTag
                                        ).toFixed(2)
                                    ); // 特殊处理
                                }
                                seriesList.push({
                                    name: '退货成功',
                                    data: successAmount
                                });
                                seriesList.push({
                                    name: '退货申请',
                                    data: amount
                                });

                                data = {
                                    tag: tag,
                                    xDataList: xDataList,
                                    seriesList: seriesList
                                };
                            }
                            this.fieldServiceData = data;
                        } else {
                            this.fieldServiceData = null
                        }
                    }
                });
            },
            // 获取退货商品分布情况数据
            getCommodityType () {
                let params = {
                    reginCode: this.userInfo.regionCode,
                    sort: this.productDistributionSort,
                    endTime: this.endTime,
                    startTime: this.startTime
                };
                this.commodityData = [];
                api.commodityType(params).then((res) => {
                    let data = { dimensions: ['name', 'value'], source: [], tag: '' };
                    if (res.ret === 0) {
                        let datalist = res.data.commodityTypeMap;
                        if (datalist.length) {
                            let sourceInfo = [];
                            let tag = '';
                            let priceTag = 1;
                            if (this.productDistributionSort === 'count') {
                                tag = '个';
                                for (let i = 0; i < datalist.length; i++) {
                                    let inlineInfo = [];
                                    inlineInfo.push(datalist[i].name);
                                    inlineInfo.push(parseInt(datalist[i].count));
                                    sourceInfo.push(inlineInfo);
                                }
                            } else {
                                let hasWY = datalist.some(function (currentValue, index, arr) {
                                    return currentValue.amount > 10000;
                                });
                                if (hasWY) {
                                    tag = '万元';
                                    priceTag = 10000;
                                } else {
                                    tag = '元';
                                    priceTag = 1;
                                }
                                for (let i = 0; i < datalist.length; i++) {
                                    let inlineInfo = [];
                                    inlineInfo.push(datalist[i].name);
                                    inlineInfo.push((datalist[i].amount / priceTag).toFixed(2));
                                    sourceInfo.push(inlineInfo);
                                }
                            }

                            data.source = sourceInfo;
                            data.tag = tag;
                        }
                        this.commodityData.push(data);
                    }
                });
            },
            // 处理满意度分布情况
            getTouristEvaluation () {
                let params = {
                    reginCode: this.userInfo.regionCode,
                    endTime: this.endTime,
                    startTime: this.startTime
                };
                api.touristEvaluation(params).then((res) => {
                    if (res.ret === 0) {
                        this.touristEvaluationData = res.data.touristEvaluationMap
                        this.touristEvaluationData.map(i => {
                            i.color = this.touristEvaluationColor[i.type]
                        })
                    } else {
                        this.touristEvaluationData = []
                    }
                });
            },
            // 游客来源地分布Top10
            getCustomerComingTop10 () {
                let params = {
                    reginCode: this.userInfo.regionCode,
                    endTime: this.endTime,
                    startTime: this.startTime
                };
                api.getTouristSource(params).then((res) => {
                    let data = { dimensions: ['name', 'value'], source: [], tag: '' };
                    if (res.ret === 0) {
                        let datalist = res.data.touristSourceMap ? res.data.touristSourceMap : [];
                        if (datalist.length) {
                            let sourceInfo = [];
                            let tag;
                            let chartsTag;
                            if (
                                datalist.some(function (currentValue, index, arr) {
                                    return parseInt(currentValue.count) > 10000;
                                })
                            ) {
                                tag = '万人';
                                chartsTag = 10000;
                            } else {
                                tag = '人';
                                chartsTag = 1;
                            }
                            // if (this.productDistributionSort === "count") {
                            //   for (let i = 0; i < datalist.length; i++) {
                            //     let inlineInfo = [];
                            //     inlineInfo.push(datalist[i].name);
                            //     inlineInfo.push(parseInt((parseInt(datalist[i].count)/chartsTag)));
                            //     sourceInfo.push(inlineInfo);
                            //   }
                            // }

                            // data.source = sourceInfo;
                            // data.tag = tag;

                            let source = [];
                            res.data.touristSourceMap &&
                                res.data.touristSourceMap.forEach((item) => {
                                    source.push([item.name, item.count]);
                                });

                            this.customerFromData = [
                                {
                                    dimensions: ['name', 'value'],
                                    source: source
                                },
                                {
                                    transform: {
                                        type: 'sort',
                                        config: { dimension: 'value', order: 'desc' }
                                    }
                                }
                            ];

                            this.customerFromData.push(data);
                        } else {
                            this.customerFromData = [
                                {
                                    dimensions: ['name', 'value'],
                                    source: [['', 0]]
                                },
                                {
                                    transform: {
                                        type: 'sort',
                                        config: { dimension: 'value', order: 'desc' }
                                    }
                                }
                            ]
                        }
                    }
                });
            },
            changeCityDistribution (cheeseIndex) {
                if (cheeseIndex === 1) {
                    this.returnQuantityAndSort = 'amount';
                } else {
                    this.returnQuantityAndSort = 'count';
                }
                this.cityDistributionActive = cheeseIndex;
                this.getFieldService();
            },
            changeProductDistribution (cheeseIndex) {
                if (cheeseIndex === 1) {
                    this.productDistributionSort = 'amount';
                } else {
                    this.productDistributionSort = 'count';
                }
                this.productDistributionActive = cheeseIndex;
                this.getCommodityType();
            },
            close () {
                this.openChooseTimePop = false;
            },
            open () {
                this.openChooseTimePop = true;
            },
            confirm (value, arr) {
                if (value === '全部年份') {
                    this.time = '时间';
                    this.startTime = '';
                    this.endTime = '';
                } else {
                    this.time = value;
                    this.startTime = arr[0].replace(/\//g, '-');
                    this.endTime = arr[1].replace(/\//g, '-');
                }
                this.initData();
            },
            toCommonList (item, index, type) {
                let typeList = [];
                this.touristEvaluationData.forEach((item) => {
                    typeList.push({
                        F_NAME: item.type,
                        count: item.count
                    });
                })
                typeList.forEach((item) => {
                    switch (item.F_NAME) {
                    case '不满意':
                        item.comment = 1;
                        break;
                    // case '一般满意':
                    case '基本满意':
                        item.comment = 3;
                        break;
                    // case '非常满意':
                    case '满意':
                        item.comment = 5;
                        break;
                    }
                })
                sessionStorage.removeItem('optionList');
                sessionStorage.setItem('optionList', JSON.stringify(typeList));
                // 跳转到公共列表
                this.$router.push({
                    path: '/refund/commonList',
                    query: {
                        optionList: typeList,
                        activeIndex: index
                    }
                });
            }
        }
    };
</script>

<style lang="less" scoped>
.content-top {
  padding: 20px 12px 72px;
  background-color: #f9fafc;
  box-sizing: border-box;
  color: #1e2226;
}
.analyzed-area {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 20px;
}
.part {
  margin-bottom: 12px;
  padding: 12px 16px 20px;
  background-color: #fff;
  border-radius: 2px;
}
.part .part-title {
  margin-bottom: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.part .shouli {
  margin-bottom: 0;
}
.part .part-title .switch-btn {
  display: flex;
  border-radius: 2px;
  border: 0.5px solid #36b374;
}
.part .part-title .switch-btn .radio {
  padding: 6px 10px;
  font-size: 12px;
  line-height: 12px;
  color: #36b374;
}
.part .part-title .switch-btn .active {
  color: #fff;
  background-color: #36b374;
}
.part .part-title span {
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
}
.deak-overview-child {
  margin-top: 12px;
  padding: 16px;
  background-color: #f9fafc;
}
.deak-overview-child .child-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
}
.deak-overview-child .child-num {
  margin: 4px 0 7px;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
}
.deak-overview-child .child-num .tags {
  font-size: 12px;
  line-height: 17px;
  color: #71747a;
}
.deak-overview-child .full-desc {
  font-size: 12px;
  line-height: 17px;
  color: #71747a;
}
.deak-overview-child .full-desc .num {
  font-size: 14px;
  line-height: 17px;
  color: #1e2226;
  font-weight: bold;
}
.icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}
.analyzed-area .icon {
  width: 16px;
  height: 16px;
  margin-right: 1px;
}
.footer {
  position: fixed;
  bottom: 0;
  padding: 20px 0;
  display: flex;
  width: 100%;
  background: white;
  .foot-item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    .left-icon {
      width: 16px;
      height: 16px;
    }
    .text {
      font-size: 16px;
      color: #36b374;
      font-weight: 500;
      margin-left: 2px;
    }
    .right-icon {
      width: 12px;
      height: 12px;
      margin-left: 5px;
    }
  }
}

/* 预留 */
.histogram {
  display: flex;
  height: 200px;
  background-color: white;
  align-items: center;
  justify-content: center;
  color: #1893ff;
}
/deep/.processing-satisfaction {
      .van-grid-item__content--center {
        .type {
          display: flex;
          width: 100%;
          .round {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-right: 6px;
            background-color: red;
          }
          .greenRound {
            background-color: #3BC07C;
          }
          .blurRound {
            background-color: #66AEF8;
          }
          .orangeRound {
            background-color: #FFB469;
          }
          span {
            font-size: 12px;
            color: #71747A;
            font-weight: 400;
          }
        }
        .percentage {
          font-weight: Bold;
          font-size: 14px;
          color: #1E2226;
          padding-left: 25px;
          line-height: 17px;
          width: 100%;
          margin-bottom: 4px;
        }
        .number {
          font-size: 12px;
          color: #71747A;
          font-weight: 400;
          display: flex;
          align-items: center;
          padding-left: 12px;
          line-height: 17px;
          width: 100%;
        }
      }
    }
</style>
